import { Box, Typography } from "@mui/material";
import Image from "next/image";
import application_assessments_example from "@/assets/images/application_assessments_example.png";

export function AssessmentsDefinition() {
	return (
		<>
			<Typography variant='body2'>
				As perguntas de enquadramento são questões a serem respondidas no
				momento em que uma organização cadastra uma nova aplicação.
			</Typography>

			<Box>
				<Image
					loading='lazy'
					width={320}
					placeholder='blur'
					src={application_assessments_example}
					style={{ borderRadius: "0.25rem" }}
					alt='perguntas de enquadramento no momento de cadastro de uma nova aplicação'
				/>
				<Typography component={"p"} variant='caption' sx={{ paddingLeft: 0.5 }}>
					Perguntas de enquadramento no momento de cadastro de uma nova
					aplicação
				</Typography>
			</Box>

			<Typography variant='body2'>
				As perguntas de enquadramento são vinculadas às AIAs. Dessa forma se
				busca identificar quais AIAs a aplicação da organização deve responder.
			</Typography>

			<Typography variant='body2'>
				A aplicação deve responder todas as AIAs nas quais ela respondeu "Sim"
				para a pergunta de enquadramento. Note que é possível que uma mesma AIA
				possa ter mais de uma pergunta de enquadramento, nesse caso qualquer uma
				das respostas "Sim" para as perguntas daquela AIA já vincula a aplicação
				à responder a AIA.
			</Typography>

			<Typography variant='body2'>
				Devido ao contexto da metodologia, as perguntas de enquadramento só
				existem nas AIAs. Assim, como elas somente serão exibidas para os
				usuários das organizações responderem quando houver pelo menos um
				questionário <span style={{ fontWeight: 600 }}>publicado</span> daquela
				AIA.
			</Typography>

			<Typography variant='body2'>
				Portanto, conforme a metodologia RAIES, as perguntas de enquadramento
				servem para orientar quais temas e princípios éticos determinada
				aplicação impactam.
			</Typography>
		</>
	);
}
